import React, { FC, useEffect, useRef, useState } from 'react';
import { Tooltip } from '../Tooltip/Tooltip';
import { ChipProps, Chip } from './Chip';

interface Props extends Omit<ChipProps, 'labelRef'> {
  /*! Specify width of Chip to determinate point of truncation */
  maxWidth: string;
  toolTipText: string;
}

const shouldDisableTooltip = (el: HTMLDivElement | null): boolean => !el || el.scrollWidth <= el.clientWidth;

export const ChipWithTooltip: FC<React.PropsWithChildren<Props>> = ({ toolTipText, ...chipProps }) => {
  const [showTooltip, setTooltipState] = useState(false);
  const labelRef = useRef<HTMLDivElement>(null);
  // biome-ignore lint/correctness/useExhaustiveDependencies: exception?
  useEffect(() => {
    // Show only tooltip if we have truncation
    setTooltipState(shouldDisableTooltip(labelRef?.current));
  }, [toolTipText]);

  return (
    <Tooltip disableHoverListener={showTooltip} title={toolTipText} placement="top">
      <Chip {...chipProps} labelRef={labelRef} />
    </Tooltip>
  );
};
